import { MessagingPlatform } from '@this+that/models';
import log from 'loglevel';

import { IntegrationAccount } from '../../../models/integrationAccount';

export interface ResolvedAccount {
  account: IntegrationAccount;
  accountId: string;
  platform: MessagingPlatform;
}

export interface DraftAccount {
  accountId: string;
  platform: MessagingPlatform;
}

export const toDraftAccount = ({
  accountId,
  platform,
}: ResolvedAccount): DraftAccount => ({ accountId, platform });

export const isSameDraftAccount = (
  first: DraftAccount | undefined,
  second: DraftAccount | undefined,
): boolean =>
  Boolean(first && second) &&
  first?.accountId === second?.accountId &&
  first?.platform === second?.platform;

export const resolveEmailAccount = (
  fromEmail: string | undefined,
  currentIntegrationAccount: IntegrationAccount,
  integrationAccounts: IntegrationAccount[],
  options?: { strict?: boolean },
): ResolvedAccount | null => {
  if (fromEmail && fromEmail !== currentIntegrationAccount.displayName) {
    const selectedAccount = integrationAccounts.find(
      (account) => account.displayName === fromEmail,
    );
    if (selectedAccount) {
      return {
        account: selectedAccount,
        accountId: selectedAccount.displayName,
        platform: selectedAccount.platform as MessagingPlatform,
      };
    }
    log.warn(
      `[Draft] fromEmail "${fromEmail}" not found in integration accounts, falling back to current`,
      {
        fromEmail,
        availableAccounts: integrationAccounts.map((a) => a.displayName),
      },
    );
    if (options?.strict) {
      return null;
    }
  }

  return {
    account: currentIntegrationAccount,
    accountId: currentIntegrationAccount.displayName,
    platform: currentIntegrationAccount.platform as MessagingPlatform,
  };
};

export const resolveDraftAccount = (
  fromEmail: string | undefined,
  currentIntegrationAccount: IntegrationAccount,
  integrationAccounts: IntegrationAccount[],
  options?: { strict?: boolean },
): DraftAccount | null => {
  const resolved = resolveEmailAccount(
    fromEmail,
    currentIntegrationAccount,
    integrationAccounts,
    options,
  );
  return resolved ? toDraftAccount(resolved) : null;
};
